import React from "react";
import ContentPage, { Block } from "../components/ContentPage";

export default function CadeaubonPage() {
  return (
    <ContentPage
      title="Geef een Suriwebwinkel-cadeaubon"
      lead="Weet je niet welke producten iemand nodig heeft? Geef dan een digitale Suriwebwinkel-cadeaubon."
      ctaLabel="Koop een cadeaubon"
      secondaryLabel="Of laat de ontvanger kiezen"
      secondaryTo="/verlanglijst"
    >
      <Block>
        <p>
          De ontvanger kan zelf producten kiezen binnen het beschikbare bedrag.
          Je kunt de cadeaubon voorzien van een persoonlijke boodschap en
          versturen voor een verjaardag, feestdag of andere gelegenheid.
        </p>
      </Block>
    </ContentPage>
  );
}
